<template>
  <div class="password-container">
    <div class="password-inputs">
      <password-input v-model="password" :validation="true" :security-bar="true" />
      <spacer type="small" />
      <confirm-password-input v-model="confirmPassword" />
    </div>
    <span class="password-rules">{{ $t('password.rules') }}</span>
  </div>
</template>

<script>
import PasswordInput from '@/components/common/PasswordInput.vue';
import ConfirmPasswordInput from '@/components/common/ConfirmPasswordInput.vue';
import Spacer from '@/components/common/Spacer.vue';

export default {
  components: {
    PasswordInput,
    ConfirmPasswordInput,
    Spacer,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
    };
  },
  watch: {
    password() {
      this.comparePasswordsAndEmit();
    },
    confirmPassword() {
      this.comparePasswordsAndEmit();
    },
  },
  methods: {
    comparePasswordsAndEmit() {
      const samePassword = this.password === this.confirmPassword;
      if (this.password && samePassword) {
        this.$emit('change', this.password);
      } else {
        this.$emit('change', '');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/breakpoints';

.password-rules {
  width: 100%;
  text-align: left;
  color: $text-grey;
}

.password-container {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.password-inputs {
  display: flex;
}

@media (max-width: $login-base-breakpoint) {
  .password-inputs {
    flex-direction: column;
  }
}
</style>
